// extracted by mini-css-extract-plugin
export default {"count":"tag_count__-ekibkTx"};